import { MenuItemsType } from 'pancakeswap-uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    href: '/exchange',
    items: [
      {
        label: t('Exchange'),
        href: '/exchange',
      },
      {
        label: t('Liquidity'),
        href: '/liquidity',
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    items: [
      {
        label: t('Farms'),
        href: '/farms',
      },
      {
        label: t('Pools'),
        href: '/pools',
      },
    ],
  },
  /* {
    label: t('Win'),
    href: '/win',
    items: [],
  },
  {
    label: t('NFT'),
    href: '/nft',
    items: [],
  }, */
  {
    label: '',
    href: '/',
    icon: 'More',
    items: [
      /* {
        label: t('Info'),
        href: '/',
      },
      {
        label: t('IFO'),
        href: '/ifo',
      }, 
      {
        label: t('Voting'),
        href: '/voting',
      },
      {
        label: t('Leaderboard'),
        href: '/',
      },
      {
        label: t('Settings'),
        href: '/',
      }, */
    ],
  },
]

export default config
